import React, { useState } from 'react';
import styled from 'styled-components';
import { useUser } from '../../../common/utils/hooks';
import { FlexCol } from '../../../shared/FlexCol';
import { Body, Label } from '../../../shared/styled-components/styled_text';
import { IconInput } from '../../../shared/components/IconInput';
import { FilledButton } from '../../../shared/styled-components/styled_buttons';

interface Props {
  moveStep: () => void;
  handleAccept: (inviteLink: string) => void;
  handleInputClick: () => void;
}

export const InviteMobile: React.FC<Props> = ({ moveStep, handleAccept, handleInputClick }) => {
  const { user } = useUser();
  const [inviteLink, setInviteLink] = useState('');
  // const urlPattern = /^(https?:\/\/)[\w\-]+(\.[\w\-]+)+[\/#?]?.*$/;
  const urlPattern = /^(https?:\/\/)[\w-]+(\.[\w-]+)+[/#?]?.*$/;
  const isValid = urlPattern.test(inviteLink);

  return (
    <Container>
      <FlexCol width={'100%'} align={'center'} gap={'1.2rem'}>
        <img src={'/images/workspace-wizard/invite_character.png'} style={{ width: '20rem', height: '16rem' }} alt={'invite_character'} />
        <TitleText>
          동료가 공유해준 초대 링크를
          <br />
          붙여넣기 해주세요.
        </TitleText>
        <Body size={'m'} style={{ color: ' var(--content-color-secondary)' }}>
          초대 링크가 없다면 동료에게 초대 링크를 요청해주세요.
        </Body>
      </FlexCol>
      <FlexCol width={'100%'} align={'center'} gap={'1.2rem'}>
        <IconInput
          value={inviteLink}
          required={true}
          pattern={urlPattern}
          patternMessage='유효하지 않은 URL입니다.'
          onClick={handleInputClick}
          onChange={value => setInviteLink(value)}
          label={
            <Label size={'m'} style={{ display: 'flex' }}>
              초대 링크
            </Label>
          }
          placeholder={'http://invitation.candidate.im/'}
        />
        <FilledButton
          size={'m'}
          color={'primary'}
          style={{ width: '100%' }}
          disabled={!inviteLink || !isValid}
          onClick={() => handleAccept(inviteLink)}
        >
          워크스페이스 들어가기
        </FilledButton>
      </FlexCol>
      <FlexCol width={'100%'} align={'center'} gap={'0.2rem'}>
        <ExplainText>아직 회사에서 캔디데이트 비즈를 사용하지 않나요?</ExplainText>
        <button onClick={moveStep}>
          <ButtonText>워크스페이스 생성하기</ButtonText>
        </button>
      </FlexCol>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  padding-inline: 1.6rem;
  padding-bottom: 8rem;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2.4rem;
`;

const TitleText = styled.div`
  color: var(--content-color-primary);
  text-align: center;
  font-size: 2.4rem;
  font-weight: 700;
  line-height: 140%;
`;

const ExplainText = styled.div`
  color: var(--content-color-tertiary);
  text-align: center;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 160%;
`;

const ButtonText = styled.div`
  color: var(--mono);
  text-align: center;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 160%;

  &:hover {
    text-decoration: underline;
    text-underline-offset: 3px;
  }
`;
